// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"6451351a","453":"e1b6aa23","777":"997af055"}[chunkId] + ".chunk.js";
};